module.exports = __webpack_public_path__ + "img/plant_2_small.ccc8367e.webp";